var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInprogressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F3F6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_13625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.24 15.75C23.07 14.58 21.54 13.99 20 13.99V19.99L15.76 24.23C18.1 26.57 21.9 26.57 24.25 24.23C26.59 21.89 26.59 18.09 24.24 15.75ZM20 9.98999C14.48 9.98999 10 14.47 10 19.99C10 25.51 14.48 29.99 20 29.99C25.52 29.99 30 25.51 30 19.99C30 14.47 25.52 9.98999 20 9.98999ZM20 27.99C15.58 27.99 12 24.41 12 19.99C12 15.57 15.58 11.99 20 11.99C24.42 11.99 28 15.57 28 19.99C28 24.41 24.42 27.99 20 27.99Z",
    fill: "#667085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_13625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogressIcon);
export default __webpack_public_path__ + "static/media/inprogress-Icon.d9591ade934dd996f4d1356eecb84acd.svg";
export { ForwardRef as ReactComponent };